module.exports = __webpack_public_path__ + "img/secure-access.45e80291.png";